export default {
  showModal: state => state.showModal,
  getModalTitle: state => state.modalTitle,
  getModuleName: state => state.moduleName,
  getOptions: state => state.options,
}